@if (languages) {
  <ul class="header-languages navbar-nav d-flex justify-content-between">
    <li class="header-languages__item header-languages__title fw-bold">
      <span translate>UI.Common.Language</span>:
    </li>
    <li
      class="nav-item ps-0 text-end pe-0"
      [ngClass]="{ 'dropdown dropdown-hover': showAsDropdown }"
    >
      @if (showAsDropdown && currentLanguage) {
        <span
          id="dropdownMenuButton"
          data-toggle="dropdown"
          class="header-languages__label header-languages__label--active dropdown-hover__trigger dropdown-toggle d-inline-flex align-items-center"
        >
          {{ currentLanguage.code | translate }}
          <ng-icon
            name="matArrowDropDownOutline"
            class="ms-1"
          ></ng-icon>
        </span>
      }
      <ul
        class="language-items"
        [ngClass]="
          showAsDropdown
            ? 'dropdown-menu dropdown-menu-start dropdown'
            : 'list-inline two-items'
        "
        aria-labelledby="dropdownMenuButton"
        [class.with-jip-header]="!centralConfig.innovationSpaceId"
      >
        @for (language of languages; track language.code) {
          <li
            class="header-languages__item list-inline-item"
            [ngClass]="{ 'dropdown-item': showAsDropdown }"
            (click)="languageCode.click()"
            (keydown.enter)="languageCode.click()"
          >
            <span
              #languageCode
              class="header-languages__link"
              [ngClass]="{ 'link-downdown': showAsDropdown }"
              (click)="$event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()"
              (clickAfterChecking)="setLanguage(language)"
              [destinationHref]="getDestination(language)"
              appUnsavedFormCheck
            >
              <span
                class="header-languages__label"
                [ngClass]="{
                  'header-languages__label--active':
                    language.code === currentLanguage.code,
                }"
              >
                {{ language.code | translate }}
              </span>
            </span>
          </li>
        }
      </ul>
    </li>
  </ul>
}
